import axios from 'axios';
import { loadStorage } from '../../Utils/Utils';
import { getBaseUrl } from '../../Utils/Utils';


const apiRequest = axios.create({
    baseURL: getBaseUrl(),
});

// Set the Authorization header for all API requests
apiRequest.interceptors.request.use(
    (config) => {
        const token = loadStorage("token");
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// apiRequest.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         if (isTokenExpired(loadStorage("token"))) {
//             const dispatch = useDispatch();
//             const navigate = useNavigate();
//             navigate('/');
//             dispatch(raiseError("Please login again"));
//             dispatch(logOut());
//         }
//         return Promise.reject(error);
//     }
// );

export default apiRequest;
